import React from 'react';
import styled from 'styled-components';

import Icon from '../kingpin/atoms/Icon';

const Banner = styled.div<{ isShort?: boolean }>`
  border-radius: 4px;
  background-color: var(--color-status-error-bg);
  border: 1px solid var(--color-danger-border);
  padding: ${(props) => (props.isShort ? '12px 16px' : '16px')};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: ${(props) => (props.isShort ? 'center' : 'flex-start')};
`;

const WarningBanner = ({
  children,
  isShort,
  hideIcon,
}: {
  children: JSX.Element | JSX.Element[];
  isShort?: boolean;
  hideIcon?: boolean;
}) => (
  <Banner isShort={isShort}>
    {!hideIcon && (
      <div style={{ marginRight: 8, display: 'flex' }}>
        <Icon icon="warning" color="var(--color-status-error)" />
      </div>
    )}
    <div style={{ display: 'flex' }}>{children}</div>
  </Banner>
);

export default WarningBanner;
